// @flow

import { observer } from "mobx-react";
import React from "react";

import "./TourItem.scss";

type Props = {
    title: string,
    text: string,
    onNext: Function,
    nextButtonText: string,
    position: string
};

@observer
export default class TourItem extends React.Component<Props> {
    render() {
        const classes = [
            "TourItem",
            "TourItem--position-" + this.props.position
        ];

        return (
            <div className={classes.join(" ")}>
                <div className="TourItem__content">
                    <div className="TourItem__title">{this.props.title}</div>
                    <div className="TourItem__text">{this.props.text}</div>
                </div>

                <div className="TourItem__actions">
                    {this.renderNextButton()}
                </div>
            </div>
        );
    }

    renderNextButton() {
        const onNext = this.props.onNext;
        if (!onNext) return null;

        return (
            <button
                className="TourItem__button TourItem__button--next"
                type="button"
                onClick={onNext}
            >
                {this.props.nextButtonText}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/WatchTourItem/TourItem.js